class FeaturedProducts extends HTMLElement {
  constructor() {
    super();
   
  }

    /**
   * Sets up event listeners for the custom web component.
   * @returns {void}
   */
  connectedCallback() {
    const itemsCollection = this.querySelectorAll(".js-list-collection li");
    itemsCollection.forEach(item => {
      item.addEventListener("click", this.changeCollectionSelect.bind(this));
    });

    const openDropDown = this.querySelector(".js-selected");
    openDropDown.addEventListener('click', this.openCloseDropDownCollection.bind(this));
  }

    /**
   * Toggles the visibility of a dropdown list when an element is clicked.
   * @param {MouseEvent} e - The click event that triggered the method.
   * @returns {void}
   */
  openCloseDropDownCollection(e) {
    const parent = e.target.closest('.js-filter-drop');
    const listContainer = parent.querySelector('.js-list-collection');

    parent.dataset.active = !(listContainer.dataset.active === "true");
    listContainer.dataset.active = !(listContainer.dataset.active === "true");
  }

    /**
   * Updates the "View All" link for a collection with a new URL based on the provided handle.
   * @param {string} handleCollection - The handle of the collection to link to.
   * @returns {void}
   */
  changeLinkViewAll(handleCollection) {
    const linkContainer = this.querySelector('.url-collection-js');
    const url = `${window.location.pathname}/${handleCollection}`;

    linkContainer.setAttribute('href', url);
  }

    /**
   * Handles the selection of a collection and updates the UI accordingly.
   * @param {MouseEvent} e - The click event that triggered the method.
   * @returns {void}
   */
  changeCollectionSelect(e) {
    const nameCollection = e.target.textContent;
    const handleCollection = e.target.dataset.handle;

    const colecctionSelected = this.querySelector(".js-selected");
    colecctionSelected.textContent = nameCollection;

    this.openCloseDropDownCollection(e);
    this.changeLinkViewAll(handleCollection);

    this.getNewCollectionByHandle(handleCollection);
  }

    /**
   * Fetches and displays a new collection based on its handle.
   * @param {string} handleCollection - The handle of the collection to fetch.
   * @returns {void}
   */
  getNewCollectionByHandle(handleCollection) {
    const url = `${window.location.pathname}/${handleCollection}?section_id=main-collection-product-grid`

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = this.stringToHTML(responseText).querySelector("#product-grid")
        this.renderListNewCollection(html);
      });
  }

    /**
   * Renders a new collection of products in the UI.
   * @param {HTMLUListElement} listProductsUl - The unordered list element containing the new collection of products.
   * @returns {void}
   */
  renderListNewCollection(listProductsUl) {
    const containerGridList = this.querySelector(".product-grid");
    containerGridList.innerHTML = "";

    const firstFourItems = Array.from(listProductsUl.children).slice(0, 8);
    containerGridList.append(...firstFourItems);

    let element = document.querySelector('.relate-products__slider');
    let section_id = element.getAttribute('data-section-id');
    let selector = '#' + element.id;
    new Swiper(selector, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      centeredSlides: false,
      centerInsufficientSlides: true,
      loopedSlides: 4,
      roundLengths: true,
      speed: 1000,
      breakpoints: {
        280: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        490: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        800: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      },
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        prevEl: `.kings-home-collection__buttons--prev--${section_id}`,
        nextEl: `.kings-home-collection__buttons--next--${section_id}`
      }
    });
  }

    /**
   * Converts an HTML string into a manipulable HTML element.
   * @param {string} htmlString - The HTML string to convert into an HTML element.
   * @returns {HTMLDivElement} The HTML element created from the HTML string.
   */
  stringToHTML(htmlString) {
    const div = document.createElement('div');
    div.innerHTML = htmlString;
    return div;
  }
}

customElements.define('fetured-products', FeaturedProducts);